import React, { FC } from 'react';
import Text from '../Text';
import * as CheckboxStyles from './_checkbox.module.scss';

type CheckboxProps = {
    label: string,
    isChecked?: boolean,
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
    disabled?: boolean,
    isReversed?: boolean
}

const Checkbox: FC<CheckboxProps> = ({
    label,
    isChecked = false,
    onChange,
    disabled = false,
    isReversed = false,
}) => {
    return (
        <div className={CheckboxStyles.container}>
            {
                !isReversed && <Text
                    label={label}
                    className={CheckboxStyles.label}
                />
            }

            <input
                type='checkbox'
                checked={isChecked}
                onChange={onChange}
                disabled={disabled}
                className={CheckboxStyles.input}
            />

            {
                isReversed && <Text
                    label={label}
                    className={CheckboxStyles.label}
                />
            }
        </div>
    );
};

export default Checkbox;
